<template>
  <div class="merchant">
    <!-- 搜索框 -->
    <div class="search-box">
      <span style="padding-right:16px">商户名称</span>
      <el-select
        size="mini"
        filterable
        v-model="searchName"
        placeholder="请选择"
        style="width: 20vw"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        style="margin:0 20px"
        type="primary"
        size="mini"
        icon="el-icon-search"
        @click="filterData"
        >查询</el-button
      >
      <!-- <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          > -->
    </div>
    <!-- 机构列表 -->
    <div class="merchant-table">
      <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="_id"
        :row-class-name="handleDragAllow"
        border
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column prop="name" label="机构组织"> </el-table-column>
        <el-table-column prop="created" label="创建日期"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.addChildren && $jumpPerm('organize_edit')"
              @click.native.prevent="pushChildren(scope.row)"
              type="text"
              size="small"
              style="padding-right:20px"
              >添加下一级</el-button
            >
            <el-popconfirm
              placement="top"
              title="您确定删除吗?"
              icon="el-icon-info"
              icon-color="red"
              @confirm="removeChildren(scope.row)"
            >
              <el-button
                v-if="!scope.row.isFirst && $jumpPerm('organize_edit')"
                type="text"
                size="small"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="新增机构"
      width="25%"
      top="30vh"
      :center="true"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="clearDialog"
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="机构名称" prop="name" label-width="80px">
          <el-input
            v-model="formData.name"
            placeholder="请输入机构名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { transformTreeData, flattenTree } from "@/utils/util";
import Sortable from "sortablejs";
import {
  merchantLists,
  merchantSearch,
  merchantAdd,
  merchantRemove,
  merchantResort
} from "@/api/merchantApi";
export default {
  data() {
    return {
      // 搜索框选中项
      searchName: "",
      // 下拉框的返回数据
      options: [],
      // 表格树形数组
      tableData: [],
      // 记录新增的Pid
      pushPid: "",
      // 新增商户弹框显示
      dialogFormVisible: false,
      // 收集新增机构的名称
      formData: {
        name: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
          {
            pattern: /^(?:[\x00-\x7F]|[\u4E00-\u9FA5]){0,30}$/,
            message: "仅支持输入30位以内的字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    addFlag() {
      //添加机构权限控制
      return (
        this.$store.state.userInfo.permissions.includes(
          "businessInstitutionAdd"
        ) || this.$store.getters.isAdmin
      );
    },
    deleteFlag() {
      // 删除机构权限
      return (
        this.$store.state.userInfo.permissions.includes(
          "businessInstitutionDelete"
        ) || this.$store.getters.isAdmin
      );
    }
  },
  async created() {
    await this.getSearchOption();
    await this.getMerchantList(this.$route.query.id);
    this.tableData = transformTreeData(this.tableData);
  },
  mounted() {
    // 阻止默认行为
    document.body.ondrop = function(event) {
      event.preventDefault();
      event.stopPropagation();
    };
    // 调用 table拖拽排序
    this.rowDrop();
  },
  methods: {
    // 获取搜索框下拉列表
    async getSearchOption() {
      const { data } = await merchantSearch();
      if (data.code === 1000) {
        this.options = data.data.list.map(item => ({
          label: item.name,
          value: item._id
        }));
        // 同步搜索框选中项
        if (this.$route.query.id) {
          this.searchName = data.data.list.filter(
            item => item._id === this.$route.query.id
          )[0]._id;
        } else {
          this.searchName = data.data.list[0]._id;
        }
      } else {
        this.$message.error(data.msg);
      }
    },
    // 获取机构列表数据
    async getMerchantList(id) {
      const { data } = await merchantLists({
        business_id: id || this.options[0].value
      });
      if (data.code === 1000) {
        this.tableData = transformTreeData(data.data.data);
      } else {
        this.$message.error(data.msg);
      }
    },
    // 通过搜索框查询机构
    filterData() {
      this.getMerchantList(this.searchName);
    },
    // 重置按钮
    // reset(){},
    // 添加下一级按钮
    pushChildren(row) {
      this.pushPid = row._id;
      this.dialogFormVisible = true;
    },
    // 提交新增按钮
    async submitAdd() {
      const { data } = await merchantAdd({
        pid: this.pushPid,
        name: this.formData.name
      });
      if (data.code === 1000) {
        this.dialogFormVisible = false;
        this.getMerchantList(this.searchName);
      } else {
        this.$message.error(data.msg);
      }
    },
    // 关闭弹框
    clearDialog() {
      this.formData.name = "";
    },
    // 删除机构
    async removeChildren(row) {
      console.log(row);
      const { data } = await merchantRemove({
        id: row._id
      });
      if (data.code === 1000) {
        this.getMerchantList(this.searchName);
      } else {
        this.$message.error(data.msg);
      }
    },
    // 添加可拖拽表格行类名
    handleDragAllow(row, rowIndex) {
      if (row.rowIndex === 0) {
        return "noDragAllow";
      } else {
        return "dragAllow";
      }
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        draggable: ".dragAllow", // 表格第一行不支持拖拽设置
        async onEnd({ newIndex, oldIndex }) {
          console.log("newId", newIndex);
          console.log("oldId", oldIndex);
          const flatArray = flattenTree(_this.tableData);
          console.log("oldRow", flatArray[oldIndex]);
          console.log("newRow", flatArray[newIndex]);
          const { data } = await merchantResort({
            id: flatArray[oldIndex]._id,
            pid: flatArray[newIndex].pid,
            low_id: flatArray[newIndex]._id
          });
          if (data.code === 1000) {
            _this.getMerchantList(_this.searchName);
          } else {
            _this.$message.error(data.msg);
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.merchant {
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px;
  .search-box {
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px solid #e5e6eb;
  }
  .merchant-table {
    margin-top: 20px;
  }
}
</style>
